import React from 'react'

export default function Refunds_Policy() {
    return (
        <div className='tc_cms_pages_wrapper  py-5 animate__animated animate__fadeIn'>

            <div className="container">

                <div className='main'>
                    <h1><span>Refund Policy</span></h1>
                    <p><strong>Navchr Online</strong></p>
                    <p>Legal/GST Name: Navchr Online</p>
                    <p>Website: https://www.navchr.com</p>
                    <p>Effective Date: 01/01/2026</p>

                    <h3>1. General Refund Policy</h3>
                    <p>All refund requests must be raised directly with Navchr Online.</p>
                    <p>Airlines or third-party service providers will not process refunds for bookings made through our platform.</p>
                    <p>It is mandatory for customers to contact Navchr Online via email or phone for all refund-related queries.</p>

                    <h3>2. Refund Request Process</h3>
                    <p>Customers must inform Navchr Online about any cancellation (including cancellations made directly with the airline) via:</p>
                    <ul>
                        <li>Email: <a href="mailto:support@navchr.com">support@navchr.com</a></li>
                        <li>Phone: <a href="tel:9336111631">9336111631</a></li>
                    </ul>
                    <p>Refund requests must be raised within a reasonable time from the date of cancellation.</p>

                    <h3>3. Refund Processing Timeline</h3>
                    <p>Refunds are generally initiated within 72 hours after approval.</p>
                    <p>Once processed, the refund amount will be credited to the customer's original payment method / bank account within 15–17 business days, depending on the bank or payment provider.</p>

                    <h3>4. Dependency on Airline / Service Provider</h3>
                    <p>Navchr Online will process refunds only after receiving the eligible refund amount from the respective airline or service provider.</p>
                    <p>In case the airline delays or fails to process the refund, Navchr Online shall not be held responsible for such delays.</p>
                    <p>If an airline ceases operations, refunds will be processed only after funds are received from the airline.</p>

                    <h3>5. Cancellation Charges</h3>
                    <p>If a user cancels a flight ticket:</p>
                    <ul>
                        <li>A cancellation charge of ₹100 + 18% GST (₹118 total) per passenger will be applicable.</li>
                        <li>A transaction charge of 2% may also be deducted.</li>
                        <li>These charges are non-refundable.</li>
                    </ul>

                    <h3>6. Convenience Fee</h3>
                    <p>In all cases including:</p>
                    <ul>
                        <li>Cancellation by user</li>
                        <li>Cancellation by airline</li>
                        <li>Force majeure / Act of God</li>
                    </ul>
                    <p>The convenience fee charged at the time of booking is non-refundable.</p>

                    <h3>7. Final Refund Amount</h3>
                    <p>The final refund amount will be calculated as per:</p>
                    <ul>
                        <li>Airline cancellation policies</li>
                        <li>Applicable deductions (charges, fees, taxes)</li>
                    </ul>
                    <p>The remaining eligible amount will be credited to the customer's bank account.</p>

                    <h3>8. No-Show Policy</h3>
                    <p>If a customer fails to board any segment of their journey:</p>
                    <ul>
                        <li>The airline reserves the right to cancel onward or return bookings.</li>
                        <li>Navchr Online is not responsible for such cases and no refund may be applicable as per airline policy.</li>
                    </ul>

                    <h3>9. Limitation of Liability</h3>
                    <p>Navchr Online acts only as a booking intermediary.</p>
                    <p>We are not responsible for airline policies, delays, or operational issues.</p>
                    <p>Refunds are strictly subject to airline/service provider approval.</p>

                    <h3>10. Contact Information</h3>
                    <p>Navchr Online</p>
                    <p>Plot No 10, Baniya Ka Bagh, Jaipur Bye Pass, Alwar, Rajasthan – 301001</p>
                    <p>Phone: <a href="tel:9336111631">9336111631</a></p>
                    <p>Email: <a href="mailto:support@navchr.com">support@navchr.com</a></p>
                </div>

            </div>
        </div>
    )
}
